import { AnimatePresence, motion } from 'framer-motion'
import RenderIf from './RenderIf'
import Typography from './Typography'
import Button from './Button'
import { ReactNode } from 'react'
import { cn } from '@/utils/common'

// Define types for the Modal props
interface ModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  title?: string | ReactNode
  description?: string | ReactNode
  confirmText?: string
  cancelText?: string
  onConfirm?: () => void
  onCancel?: () => void
  className?: string
}

// Modal component
export const Modal = ({
  isOpen,
  setIsOpen,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  className,
}: ModalProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsOpen(false)}
          className='fixed inset-0 z-50 grid cursor-pointer place-items-center overflow-y-scroll bg-slate-900/20 p-8 backdrop-blur'
        >
          <motion.div
            initial={{ scale: 0, rotate: '12.5deg' }}
            animate={{ scale: 1, rotate: '0deg' }}
            exit={{ scale: 0, rotate: '0deg' }}
            onClick={e => e.stopPropagation()}
            className='relative w-full max-w-lg cursor-default space-y-4 overflow-hidden rounded-3xl bg-onSecondary-1 p-6 shadow-xl'
          >
            <div className={cn('relative z-10', className)}>
              {/* <div className='mx-auto mb-2 grid h-16 w-16 place-items-center rounded-full bg-white text-3xl text-indigo-600'>
                ):
              </div> */}
              <RenderIf isTrue={typeof title === 'string'} render={title}>
                <h3 className='mb-2 text-center text-3xl font-bold'>{title}</h3>
              </RenderIf>
              <RenderIf
                isTrue={typeof description === 'string'}
                render={description}
              >
                <Typography
                  className='text-primary-gr mb-6'
                  variant='h6'
                  weight='semibold'
                  center
                >
                  {description}
                </Typography>
              </RenderIf>
              <div className='flex gap-2'>
                <RenderIf isTrue={cancelText}>
                  <Button
                    fullWidth
                    onClick={() => {
                      setIsOpen(false)
                      onCancel?.()
                    }}
                    className='w-full rounded bg-transparent py-2 font-semibold text-white transition-colors hover:bg-white/10'
                  >
                    {cancelText}
                  </Button>
                </RenderIf>
                <RenderIf isTrue={confirmText}>
                  <Button
                    fullWidth
                    onClick={() => {
                      setIsOpen(false)
                      onConfirm?.()
                    }}
                  >
                    {confirmText}
                  </Button>
                </RenderIf>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
